import React, { useEffect, useRef, useState } from 'react';
import {
  Typography,
  Container,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  AccordionDetails,
  AccordionSummary,
  Accordion,
  Button,
  Box,
  Modal,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { deleteFirmAction, getUserFirmsAction } from './APIs/action';
import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import _ from 'lodash';
import DealerShipDetail from './Component/DealerShipDetail';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DeleteOutline } from '@mui/icons-material';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import TerrainOutlinedIcon from '@mui/icons-material/TerrainOutlined';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import { GetMeAction, refreshTokenAction } from '../Onboarding/auth/action';
import { getSecondaryPermissionsAction } from '../../screen/auth/action';
import OwnersDetails from './Component/OwnersDetails';
import BasicDetailCard from './Component/BasicDetailCard';
import GeographyDetailCard from './Component/GeographyDetailCard';

const FirmDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firmList, setFirmList] = useState([]);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const dealershipRef = useRef([]);
  const basicDetailRef = useRef([]);
  const geographyRef = useRef([]);
  const ownerRef = useRef([]);

  const scrollToSection = (refArray, index) => {
    setExpandedAccordion(index);
    setTimeout(() => {
      if (refArray[index]) {
        refArray[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 1000);
  };

  const allFirms = async () => {
    const { data, error, message } = await getUserFirmsAction();

    if (!error) {
      setFirmList(data);
    } else {
      return toast.error(message);
    }
  };

  useEffect(() => {
    allFirms();
  }, []);
  const onAddFirm = () => {
    dispatch({
      type: 'RESET_FIRM_ONBOARDING_REDUCER',
    });

    dispatch({
      type: 'SET_ADDING_FIRM_FROM_PROFILE',
      data: true,
    });
    navigate('/FetchFirmDetail');
  };

  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const handleModalOpen = (firm) => {
    setOpen(true);
    setModalData(firm);
  };
  const handleModalClose = () => {
    setOpen(false);
    setModalData({});
  };
  const onDeleteFirm = async () => {
    const { data, error, message } = await deleteFirmAction({
      company_id: modalData.company_id,
    });
    if (!error) {
      const { error: userError, data: loggedInUser } = await GetMeAction();
      const { error: tokenError, data: tokenData } = await refreshTokenAction();
      const { data: secPermissionData } = await getSecondaryPermissionsAction();
      if (!userError && loggedInUser) {
        if (tokenData) localStorage.setItem('token', tokenData);
        dispatch({ type: 'SET_USER', data: loggedInUser });
        dispatch({
          type: 'SET_SECONDARY_PERMISSION',
          data: secPermissionData,
        });
        dispatch({
          type: 'SET_SECONDARY_PERMISSION_ROLES',
          data: secPermissionData.map((item) => item.role_name),
        });
      }

      handleModalClose();
      toast.success('Firm Deleted Successfully');
      setTimeout(() => {
        navigate(0);
      }, 1000);
    } else {
      return toast.error(message);
    }
  };

  const deleteFirmModal = (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Are you sure you want to Delete your Firm {modalData?.company_name}?
        </Typography>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '3rem' }}
        >
          <Button
            variant='outlined'
            color='success'
            onClick={() => handleModalClose()}
          >
            No
          </Button>
          <Button
            variant='outlined'
            color='error'
            onClick={() => onDeleteFirm()}
          >
            Delete Firm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );

  return (
    <>
      {deleteFirmModal}
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '5rem',
          height: window.innerHeight,
          overflowY: 'auto',
        }}
      >
        <Stack
          direction='row'
          spacing={2}
          justifyContent={'space-between'}
        >
          <Typography variant='h4'>Firm Details</Typography>
          <Button
            variant='outlined'
            onClick={onAddFirm}
          >
            Add Firm
          </Button>
        </Stack>

        <Divider sx={{ mt: '1rem', mb: '3rem' }} />
        {firmList &&
          firmList.length > 0 &&
          firmList.map((firm, index) => {
            return (
              <Accordion
                key={index}
                expanded={expandedAccordion === index}
                onChange={() => {
                  setExpandedAccordion(
                    expandedAccordion === index ? null : index,
                  );
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    py: 1,
                  }}
                >
                  <Stack
                    display={'flex'}
                    direction={'row'}
                    alignItems={'center'}
                    spacing={2}
                  >
                    <Typography
                      fontSize={'1rem'}
                      fontWeight={'bold'}
                      sx={{ mr: 1 }}
                    >
                      {firm.company_name}
                    </Typography>
                    <Stack
                      direction={'row'}
                      spacing={2}
                    >
                      <Tooltip
                        title={
                          <Typography sx={{ fontSize: '12px' }}>
                            View DealerShip Details
                          </Typography>
                        }
                        arrow
                      >
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            scrollToSection(dealershipRef.current, index);
                          }}
                        >
                          <StorefrontOutlinedIcon sx={{ color: '#965324' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={
                          <Typography sx={{ fontSize: '12px' }}>
                            View Basic Details
                          </Typography>
                        }
                        arrow
                      >
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            scrollToSection(basicDetailRef.current, index);
                          }}
                        >
                          <AccountBoxOutlinedIcon sx={{ color: '#C37429' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={
                          <Typography sx={{ fontSize: '12px' }}>
                            View Geography Details
                          </Typography>
                        }
                        arrow
                      >
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            scrollToSection(geographyRef.current, index);
                          }}
                        >
                          <TerrainOutlinedIcon sx={{ color: '#F59C1E' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title={
                          <Typography sx={{ fontSize: '12px' }}>
                            View Owner Details
                          </Typography>
                        }
                        arrow
                      >
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            scrollToSection(ownerRef.current, index);
                          }}
                        >
                          <SupervisedUserCircleIcon sx={{ color: '#C37429' }} />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                {/* DealerShipDetails */}
                <AccordionDetails
                  ref={(el) => (dealershipRef.current[index] = el)}
                >
                  <DealerShipDetail
                    data={firm?.dealership_companies}
                    firmData={firm}
                  />
                </AccordionDetails>
                {/* basicDetail */}
                <AccordionDetails
                  ref={(el) => (basicDetailRef.current[index] = el)}
                >
                  <BasicDetailCard
                    firmData={firm}
                    onRefresh={() => allFirms()}
                  />
                </AccordionDetails>
                {/* Geographydetails */}
                <AccordionDetails
                  ref={(el) => (geographyRef.current[index] = el)}
                >
                  <GeographyDetailCard
                    firmData={firm}
                    onRefresh={() => allFirms()}
                  />
                </AccordionDetails>

                {/* Owners Details */}
                <AccordionDetails ref={(el) => (ownerRef.current[index] = el)}>
                  <OwnersDetails
                    firmDetails={firm}
                    onRefresh={() => allFirms()}
                  />
                </AccordionDetails>

                <AccordionDetails>
                  <Stack
                    direction='row-reverse'
                    spacing={2}
                  >
                    <Button
                      variant='outlined'
                      size='small'
                      color='error'
                      onClick={() => handleModalOpen(firm)}
                    >
                      Delete Firm <DeleteOutline sx={{ ml: 1 }} />
                    </Button>
                  </Stack>
                </AccordionDetails>

                <Box sx={{ mt: '3rem', mb: '1rem' }} />
              </Accordion>
            );
          })}
      </Container>
    </>
  );
};

export default FirmDetail;
